import { render, staticRenderFns } from "./BaseFormReport.vue?vue&type=template&id=59706888&scoped=true&"
import script from "./BaseFormReport.vue?vue&type=script&lang=js&"
export * from "./BaseFormReport.vue?vue&type=script&lang=js&"
import style0 from "./BaseFormReport.vue?vue&type=style&index=0&id=59706888&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59706888",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabs})
